<script setup lang="ts">
const colorMode = useColorMode();
const isLight = computed(() => colorMode.value !== "dark");

interface TailoredCard {
  svg?: string;
  svgIcon?: string;
  title?: string;
  description?: string;
  link?: string;
  iconAppendClass?: string;
}

const props = withDefaults(
  defineProps<{
    cards: TailoredCard[];
    heading?: string;
    subcopy?: string;
    ctaText?: string;
    ctaLink?: string | null;
    appendClass?: string;
    headingClass?: string;
  }>(),
  {
    heading: "",
    subcopy: "",
    ctaText: "",
    ctaLink: null,
    appendClass: "",
    headingClass: "",
  },
);

const emit = defineEmits<{
  "cta-clicked": [];
}>();
</script>

<template>
  <section
    class="mt-24 lg:mt-[100px] mb-16 lg:mb-[100px]"
    aria-label="Key Capabilities"
  >
    <div class="text-center mb-10">
      <h2
        class="text-[28px] lg:text-[48px] font-semibold leading-tight font-avant-demi"
        :class="headingClass"
        style="
          background: linear-gradient(92deg, #12dbff -3.57%, #ba55fe 80.72%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        "
      >
        {{ heading }}
      </h2>
      <p
        v-if="subcopy"
        class="mt-3 max-w-[500px] mx-auto text-[16px] lg:text-[18px] font-normal tracking-[0.36px] font-avant"
        :class="isLight ? 'text-black opacity-70' : 'text-white opacity-70'"
      >
        {{ subcopy }}
      </p>
    </div>

    <div
      class="grid max-sm:max-w-[350px] mx-auto max-sm:place-content-left sm:grid-cols-2 lg:grid-cols-3 gap-x-2 gap-y-6 px-4"
    >
      <WrTailored :content="cards" :append-class="appendClass" />
    </div>

    <div v-if="ctaText" class="flex justify-center mt-8">
      <WrButton
        :link="ctaLink || undefined"
        @click="!ctaLink ? emit('cta-clicked') : undefined"
        container-class="h-[48px]"
        append-class="text-base font-normal px-6"
      >
        {{ ctaText }}
      </WrButton>
    </div>
  </section>
</template>
